import React from 'react';
import { Spinner } from 'reactstrap';
import { KaSelect, KaSelectOption } from '../KaSelect';
import SpinnerButton from '../SpinnerButton';
import { ConnectorSync } from './useConnectorSync';

interface ConnectorFetchViewProps {
  sync: ConnectorSync;
  entityLabel: string;
  children: React.ReactNode;
}

const ConnectorFetchView = ({ sync, entityLabel, children }: ConnectorFetchViewProps) => {
  if (sync.state === 'processing') return <>{children}</>;

  if (sync.state === 'polling') {
    return (
      <div className="text-center" style={{ paddingTop: '12rem' }}>
        <Spinner className="mb-3" aria-busy="true" style={{ width: '3rem', height: '3rem' }} />
        <p className="text-muted">Waiting for connector at {sync.selectedOption?.label}…</p>
        {sync.statusError && (
          <div className="d-inline-flex align-items-start gap-2 mt-3 px-3 py-2 rounded border text-muted small text-start">
            <i className="bi-octagon-fill traffic-light-red mt-1" />
            <div>
              <div className="fw-semibold">Connector error</div>
              <div>{sync.statusError}</div>
            </div>
          </div>
        )}
      </div>
    );
  }

  if (sync.state === 'error') {
    return (
      <div className="text-center py-4">
        <SpinnerButton spinning={false} className="btn-ghost-secondary" onClick={sync.retry}>
          Try again
        </SpinnerButton>
      </div>
    );
  }

  return (
    <div className="d-flex justify-content-center" style={{ paddingTop: '8rem' }}>
      <div style={{ width: '340px' }} className="text-center">
        <div className="mb-4 text-start">
          <label className="form-label fw-semibold mb-1">Site</label>
          <KaSelect
            value={sync.selectedOption}
            options={sync.siteOptions}
            onChange={opt => sync.selectSite((opt as KaSelectOption | null)?.value ?? '')}
            isDisabled={sync.state === 'fetching'}
            placeholder="Select a site..."
          />
        </div>
        <SpinnerButton
          spinning={sync.state === 'fetching'}
          className="btn-ghost-primary"
          onClick={sync.startFetch}
          disabled={!sync.selectedSiteId || sync.state === 'fetching'}
        >
          <i className="bi-cloud-arrow-down align-middle me-1" />Fetch {entityLabel} from TMX
        </SpinnerButton>
        <p className="text-muted small mt-3">This operation may take a moment to complete.</p>
        <p className="text-muted small mt-1">Constellation will suggest merges for any synced {entityLabel.toLowerCase()} that closely resemble existing records.</p>
      </div>
    </div>
  );
};

export default ConnectorFetchView;
